module.exports = __webpack_public_path__ + "img/process-04.b07b6dac.png";